<div class="w-full h-[4rem] flex gap-2 items-center p-2 xs:p-8 relative z-10 bg-white">
    <div class="flex items-center flex-shrink-0">
        <div class="flex gap-3 items-center flex-shrink-0">
            <button (click)="sidenav!.toggle()" type="button" class="xl:hidden">
                <mg-icon iconClass="text-mg-variant" iconName="menu"></mg-icon>
            </button>

            <img src="assets/svg/logo.svg" class="w-52 select-none flex-none" [class.hidden]="!isDesktop"id="logo-brokers">
        </div>
        <hr class="border-mg-gray-light border py-4 xl:flex hidden">
    </div>
    <mg-toolbar-user class="flex-1"></mg-toolbar-user>
</div>